var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cmdlist",staticClass:"page"},[_c('Header'),_c('section',[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }